import '../../style/components/advantage.css';

export default function Advatange(props) {
    return (
        <div className='advantage'>
            <div style={{backgroundImage: `url(${props.bg})`}} className="bg"></div>
            <div className='content'>
                <h3 className='text-weight-light'>{props.title}</h3>
                <p>{props.desc}</p>
            </div>
        </div>
    )
}